import { useEffect, useState } from 'react'
import { hasGivenConsent, OptanonConsentAnalyticsGroup } from '@/common/utils/cookies/hasGivenConsent'

/**
 * Returns a reactive boolean that updates whenever OneTrust consent changes
 * (both granting and revoking), without requiring a page refresh.
 */
export const useHasGivenConsent = () => {
    const [consent, setConsent] = useState<boolean | undefined>(undefined)

    const onetrustListener = (event: Event) => {
        const consentList = (event as CustomEvent).detail as string[]
        setConsent(consentList?.includes(OptanonConsentAnalyticsGroup))
    }

    useEffect(() => {
        // Sync in case consent changed between render and effect.
        setConsent(hasGivenConsent())

        window.addEventListener('OneTrustGroupsUpdated', onetrustListener)

        return () => {
            window.removeEventListener('OneTrustGroupsUpdated', onetrustListener)
        }
    }, [])

    return consent
}
